import React from 'react';
import JuridicalClientsContainer from "../containers/JuridicalClientsContainer";

const JuridicalClientsPage = () => {
    return (
        <div>
            <JuridicalClientsContainer/>
        </div>
    );
};

export default JuridicalClientsPage;